import * as React from "react"
const SvgComponent = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        {...props}
    >
        <path
            fill={props.fill ? props.fill : "#704DFF"}
            d="M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm3.358 5.646a.5.5 0 0 0-.637-.057l-.07.057L9 11.298 7.354 9.651l-.07-.058a.5.5 0 0 0-.695.696l.057.07 2 2 .07.057a.5.5 0 0 0 .568 0l.07-.058 4.004-4.004.058-.07a.5.5 0 0 0-.058-.638Z"
        />
    </svg>
)
export default SvgComponent
